module.exports = __webpack_public_path__ + "img/insta.81446b41.svg";